import { memo } from "react";

import RadioButton from "../RadioComponent";

import parse from 'html-react-parser';

import styles from "../QuestionCards/styles.module.scss";

const CourseQuestionCards = (props) => {
  const {
  questionsList,
  activeIndex,
  animate,
  handleQuestionAnswer,
  selectedAnswers,
} = props;

  const question = questionsList?.[activeIndex];
  const selectedAnswerId = selectedAnswers?.[question?.assQuestionId];

  return (
    <>
      {questionsList?.slice(activeIndex, activeIndex + 1).map((question) => (
        <div
          key={question?.assQuestionId}
          className={`${styles["question-wrapper"]} ${
            animate ? styles["stack-animate"] : ""
          }`}
        >
          <div className={styles["card-back"]}></div>
          <div className={styles["card-middle"]}></div>

          <div className={styles["question-card"]}>
            <div className={styles["question-header"]}>
              Question {activeIndex + 1}
            </div>

            <div className={styles["question-body"]}>
              <p className={styles["question-text"]}>
                {parse(question?.question || '')}
              </p>

              <div className={styles["options-grid"]}>
                {question?.answers?.map((option) => (
                  <RadioButton
                    key={option?.assAnswerId}
                    name={`question-${question?.assQuestionId}`}
                    label={option?.answer}
                    checked={selectedAnswerId === option?.assAnswerId}
                    onChange={() =>
                      handleQuestionAnswer(question , option)
                    }
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default memo(CourseQuestionCards);
